// AppInsights.js
import { ApplicationInsights, RemoteDependencyData } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import History from "../history";

const browserHistory = History;
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTKEY,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
        },
        enableUnhandledPromiseRejectionTracking: true,
        enableAjaxErrorStatusText: true,
        enableResponseHeaderTracking: true,
        enableRequestHeaderTracking: true,
        loggingLevelTelemetry: 2,
        autoTrackPageVisitTime: true,
    }
});

const Rest4XXResponseTelemetryInitializer = (envelope) => {
    if (envelope.name === RemoteDependencyData.envelopeType) {
        let statusCode = envelope.baseData.responseCode;
        // rest calls are still a success if they are in the 400 range. Also ignore anything that isn't to the resource server
        // to make sure failures to auth server are reported.
        if (statusCode >= 400 && statusCode < 500 && envelope.baseData.target.startsWith(process.env.REACT_APP_API_URL)) {
            envelope.baseData.success = true;
        }
    }
}

appInsights.loadAppInsights();
appInsights.context.application.ver = process.env.REACT_APP_BUILD_NO;
appInsights.addTelemetryInitializer(Rest4XXResponseTelemetryInitializer);


export { reactPlugin, appInsights };